import React from "react";
import { useMessageSource } from "react-message-source";
import { Exception } from "./exception";

export const TooManyOtpAttempts = ({
  renderButton,
}: {
  renderButton: () => React.JSX.Element;
}): React.JSX.Element => {
  const { getMessage } = useMessageSource();

  return (
    <Exception
      title={getMessage("Error.tooManyOtpAttempts.title")}
      description={getMessage("Error.tooManyOtpAttempts.description")}
      renderButton={renderButton}
    />
  );
};
